import React from "react";
import ModalComponent from "../../../atoms/Modal";
import DynamicForm from "Components/DynamicForm/dynamicForm";

interface ModalCreateProps {
  show: boolean
  setOpenModal: (arg: boolean) => void
  onSubmit: Function
  isUpdate: boolean
  productData: any
  formStructure: any[]
}

const submitProps = (isUpdate: boolean) => {
  return isUpdate ? { class: '', text: "Actualizar Producto" } : { class: '', text: "Crear Producto" }
}

const ModalCreate: React.FC<ModalCreateProps> = ({
                                                   show,
                                                   setOpenModal,
                                                   onSubmit,
                                                   isUpdate,
                                                   productData,
                                                   formStructure
                                                 }: ModalCreateProps) => {
  
  // Si es actualización, inyectamos los valores en la estructura del formulario
  const structureWithValues = isUpdate && productData 
    ? formStructure.map(field => ({
        ...field,
        value: productData[field.key]
      }))
    : formStructure;

  return (
    <ModalComponent show={show} setOpen={setOpenModal} title={`${isUpdate ? 'Actualizar': 'Crear'} Producto`} size="lg">
      <DynamicForm 
        key={isUpdate ? "update-product" : "create-product"} 
        structure={structureWithValues} 
        onSubmit={onSubmit} 
        submitProps={submitProps(isUpdate)} 
      />
    </ModalComponent>
  )
}

export default ModalCreate;
